import React from "react";
import styles from "./Banner.module.css";

export default function Banner() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}> Governance & </span>{" "}
            <span className={styles.accent2}>Leadership Structure</span>
          </h1>
          <p>
            Comprehensive governance framework with distinguished academic
            leaders and advisory committees
          </p>
          <div className={styles.heroActions}>
            <button className={`${styles.button} ${styles.orange}`}>
              View Leadership
            </button>
            <button className={styles.button}>Apply for Position</button>
          </div>
        </div>
      </div>
    </section>
  );
}
